export const VF_RETAIL_TOV = 'ВФ Ритейл ТОВ';
export const SOTA_TOV = 'ТОВ СОТА-АЛЬЯНС';
export const TECHNO = 'ТОВ "ЦЕТЕХНО"';
export const TJS = 'ООО «Таджикско-Китайское страхование»';
